module.exports = __webpack_public_path__ + "static/media/spades-king.2e2bab8b.png";